import React, { useEffect, useState } from "react";
import HomeV1 from "../../assets/ai.mp4";
import HomeV2 from "../../assets/cloud2.mp4";
import HomeV3 from "../../assets/cyber.mp4";
import HomeV4 from "../../assets/app.mp4";
import HomeV5 from "../../assets/web.mp4"
import "./HomeVideoCarousel.css";

const slides = [
  {
    tag: "ARTIFICIAL INTELLIGENCE",
    title: "AI That Works",
    highlight: "For Your Business.",
    description: "Put intelligent automation and machine learning to work across your business.",
    action: "Explore AI",
    href: "/services/ai-machine-learning",
    video: HomeV1,
  },
  {
    tag: "CLOUD SOLUTIONS",
    title: "Cloud Built",
    highlight: "To Scale.",
    description: "Modern cloud infrastructure that helps your teams move faster and grow confidently.",
    action: "Explore Cloud",
    href: "/services",
    video: HomeV2,
  },
  {
    tag: "CYBER SECURITY",
    title: "Security For",
    highlight: "What’s Next.",
    description: "Protect your systems, data and customers with security built into every layer.",
    action: "Explore Security",
    href: "/services",
    video: HomeV5,
  },
  {
    tag: "WEB & APPLICATION DEVELOPMENT",
    title: "Digital Products",
    highlight: "Made To Perform.",
    description: "Design and build web and mobile applications that make ambitious ideas real.",
    action: "Explore Development",
    href: "/services",
    video: HomeV4,
  },
  {
    tag: "WEB & APPLICATION DEVELOPMENT",
    title: "Digital Products",
    highlight: "Made To Perform.",
    description: "Design and build web and mobile applications that make ambitious ideas real.",
    action: "Explore Development",
    href: "/services",
    video: HomeV3,
  },
];

export default function HomeVideoCarousel() {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setCurrentSlide((active) => (active + 1) % slides.length);
    }, 6500);
    return () => window.clearInterval(timer);
  }, []);

  const goTo = (index) => setCurrentSlide((index + slides.length) % slides.length);
  const slide = slides[currentSlide];

  return (
    <section className="home-video-carousel" aria-label="Technology highlights">
      <video key={slide.video} className="home-video-carousel__video" src={slide.video} autoPlay muted loop playsInline preload="metadata" />
      {/*<div className="home-video-carousel__shade" />

      <article className="home-video-carousel__content" key={currentSlide} aria-live="polite">
        <div className="home-video-carousel__tag"><span />{slide.tag}</div>
        <h2>{slide.title}<br /><span>{slide.highlight}</span></h2>
        <p>{slide.description}</p>
        <Link className="home-video-carousel__action" to={slide.href}>{slide.action}<span>→</span></Link>
      </article>
*/}
      <button className="home-video-carousel__arrow home-video-carousel__arrow--left" type="button" onClick={() => goTo(currentSlide - 1)} aria-label="Previous slide">‹</button>
      <button className="home-video-carousel__arrow home-video-carousel__arrow--right" type="button" onClick={() => goTo(currentSlide + 1)} aria-label="Next slide">›</button>

      <div className="home-video-carousel__indicators" aria-label="Choose a slide">
        {slides.map((item, index) => (
          <button key={item.tag} type="button" className={index === currentSlide ? "is-active" : ""} onClick={() => goTo(index)} aria-label={`Go to ${item.tag} slide`} aria-current={index === currentSlide ? "true" : undefined}><span /></button>
        ))}
        </div>
      <div className="home-video-carousel__counter"><span>{String(currentSlide + 1).padStart(2, "0")}</span><i /><span>{String(slides.length).padStart(2, "0")}</span></div>
    </section>
  );
}
